import { Phone, Clock, Mail } from "lucide-react";

const TopBar = () => {
  return (
    <div className="hidden sm:block bg-accent text-accent-foreground">
      <div className="container-max flex flex-col sm:flex-row items-center justify-between px-4 py-2 text-xs sm:text-sm gap-1 sm:gap-0">
        <div className="flex items-center gap-4">
          <a href="mailto:villalobosprime.services@gmail.com" className="flex items-center gap-2 hover:text-secondary transition-colors">
            <Mail className="h-3.5 w-3.5 text-secondary" />
            <span>villalobosprime.services@gmail.com</span>
          </a>
          <div className="hidden md:flex items-center gap-2">
            <Clock className="h-3.5 w-3.5 text-secondary" />
            <span>Mon–Fri 8 AM – 7 PM · Sat 8 AM – 4 PM</span>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <a href="tel:3863209362" className="flex items-center gap-2 hover:text-secondary transition-colors font-semibold">
            <Phone className="h-3.5 w-3.5 text-secondary" />
            <span>(386) 320-9362 · English</span>
          </a>
          <a href="tel:7863065704" className="flex items-center gap-2 hover:text-secondary transition-colors font-semibold">
            <Phone className="h-3.5 w-3.5 text-secondary" />
            <span>(786) 306-5704</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
